import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import COLOR from "utils/constants/color";
import Loading from "components/Loading";
import styled from "styled-components";
import { Col, Row } from "antd";
import { DeleteModal } from "components/Dialog";
import { get, has } from "lodash";
import { handleCreateTipsBook, handleDeleteTipsBook, handleUpdateTipsBook } from "store/tips/thunks";
import VideoPicker from "../VideoPicker";
import YouTubePlayer from "components/ebook/YtPlayer";

import {
    Button,
    FormControl,
    FormHelperText,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextareaAutosize,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
    Close,
    Delete
} from '@mui/icons-material';











const VIDEO_SOURCE_VIDEO = 'video';
const VIDEO_SOURCE_YOUTUBE = 'youtube';

const TipsType = ['transcription', 'description', 'talented', 'special']
function isYoutubeUrl(url) {
  const pattern = /^(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
  return pattern.test(url);
}
const RemoveVideoButton = styled(IconButton)`
    position: absolute !important;
    z-index: 999;
    right: -8px;
    top: -12px;
    background-color: #d71010 !important;
    padding: 4px !important;
    height: 25px;
    width: 25px;
`;


const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;
const PreviewContainer = styled.div`
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
`;
const PreviewLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  color: ${COLOR.black100};
`;
const TextAreaAuto = styled(TextareaAutosize)`
    height: 200px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: hidden;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    // margin-left:5px;
    // margin-top:5px;
`;
const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: '4px',
  },
}));


const TipsModal = ({ data, close, pageId, bookId, open, setAlertSakeBar }) => {
  const [tip, setTip] = useState(null)
  const [videoSourceType, setVideoSourceType] = useState(VIDEO_SOURCE_VIDEO)
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteLoader, setDeleteLoader] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const classes = useStyles();
  const dispatch = useDispatch()

  useEffect(() => {
    if (data) {
      setTip(data)
      setVideoSourceType(get(data, 'video') ? VIDEO_SOURCE_VIDEO : (get(data, 'yt_video') ? VIDEO_SOURCE_YOUTUBE : VIDEO_SOURCE_VIDEO))
    } else {
      setTip({
        "bookId": bookId,
        color: '',
        page: pageId,
        "textTip": '',
        "texType": 'special'
      })
      setVideoSourceType(VIDEO_SOURCE_VIDEO)
    }
  }, [data, bookId, pageId])
  const onUpdate = async (tipData) => {
    if (!(tip.textTip && (tip.video || tip.yt_video))) {
      setError(true)
      return;
    }
    const finalTip = {
      ...tip,
      video: videoSourceType === VIDEO_SOURCE_VIDEO ? tip.video : null,
      yt_video: videoSourceType === VIDEO_SOURCE_YOUTUBE ? tip.yt_video : null,
    };

    setError(false)
    setLoading(true)
    let intr;
    if (data) {
      intr = await dispatch(handleUpdateTipsBook(finalTip))
    } else {
      intr = await dispatch(handleCreateTipsBook(finalTip))
    }
    if (has(intr, "id")) {
      setAlertSakeBar({
        open: true,
        message: "Teacher strategies updated successfully!",
        severity: "success"
      })
      close()
    } else {
      setAlertSakeBar({
        open: true,
        message: "Error while updating Teacher strategies!",
        severity: "error"
      })
    }
    setLoading(false)
  }
  const onDelete = async () => {
    setDeleteLoader(true)
    const intr = await dispatch(handleDeleteTipsBook(get(tip, "id")));
    if (has(intr, "id")) {
      setAlertSakeBar({
        open: true,
        message: "Teacher strategies deleted successfully!",
        severity: "error"
      })
      close()
    } else {
      setAlertSakeBar({
        open: true,
        message: "Error while deleting teacher strategies!",
        severity: "error"
      })
    }
    setDeleteLoader(false)
    setDeleteModal(false)
  }
  const handleCheckUrlChange = (e) => {
    if (!isYoutubeUrl(e.target.value)) {
      setAlertSakeBar({
        open: true,
        message: "Incorrect youtube url!",
        severity: "error"
      })
    }
  }
  const removeVideo = async (dt) =>{
    setTip(dt);
  }
  return (
    <Modal
      open={open}
      onClose={close}
      style={{ height: "100%", width: "100%" }}
    >
      <ModalContent>
        <DeleteModal
          deleteToggle={deleteModal}
          loading={deleteLoader}
          onDelete={onDelete}
          setDeleteToggle={setDeleteModal}
          message={`Are you sure you want to remove teacher strategies on pageId ${pageId}?`} />
        <Row style={{ justifyContent: "space-between" }}>
          <TitleText>
            Teacher strategies
          </TitleText>
          <IconButton
            onClick={close}
            style={{ padding: 0 }}
          >
            <Close color="secondary" />
          </IconButton>
        </Row>
        <ModalConfigArea style={{ overflowX: "hidden" }}>
          <Row
            gutter={[24, 24]}
            style={{ justifyContent: "flex-end", display: "flex" }}
          >
            {data ? <IconButton
              onClick={() => setDeleteModal(true)}
              style={{ padding: 0, marginRight: 10 }}
            >
              <Delete color="secondary" />
            </IconButton> : null}
          </Row>
          <LinkArea>
            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
              <Col span={24}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="textTip" style={{ backgroundColor: "#fff", paddingLeft: 2, paddingRight: 2 }}>Description</InputLabel>
                  <TextAreaAuto
                    id="textTip"
                    type="text"
                    minRows={3}
                    maxRows={5}
                    variant="outlined"
                    onChange={(e) => {
                      setError(false)
                      setTip({
                        ...tip,
                        textTip: e.target.value,
                      });
                    }}
                    value={get(tip, "textTip")}
                  />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
              <Col span={24}>
                <FormControl variant="outlined" className={classes.formControl} fullWidth>
                  <InputLabel id="video-source-label" style={{ backgroundColor: "#fff", paddingLeft: 2, paddingRight: 2 }}>Video source</InputLabel>
                  <Select
                    labelId="video-source-label"
                    value={videoSourceType}
                    onChange={(e) => {
                      const next = e.target.value;
                      setVideoSourceType(next);
                      // if (next === VIDEO_SOURCE_YOUTUBE) {
                      //   setTip({ ...tip, video: null });
                      // } else {
                      //   setTip({ ...tip, yt_video: '' });
                      // }
                    }}
                    label="Video source"
                  >
                    <MenuItem value={VIDEO_SOURCE_VIDEO}>Video upload</MenuItem>
                    <MenuItem value={VIDEO_SOURCE_YOUTUBE}>YouTube URL</MenuItem>
                  </Select>
                </FormControl>
              </Col>
            </Row>
            {videoSourceType === VIDEO_SOURCE_VIDEO ? (
              <Row gutter={[24, 24]}
                style={{ marginTop: 20, marginRight: 0, marginLeft: 0, position: 'relative' }}
                className="floatingLabelBG"
              >
                {get(tip, "video") ? <RemoveVideoButton
                  onClick={() => {
                    removeVideo({
                      ...tip,
                      video: null
                    })
                  }}
                >
                  <Close style={{ color: "#fff" }} />
                </RemoveVideoButton> : null}
                <VideoPicker
                  style={{ height: "auto" }}
                  hasDescription={false}
                  path={"/video/intraction"}
                  src={get(tip, "video")}
                  onChange={item => {
                    setError(false)
                    setTip({
                      ...tip,
                      video: item.url
                    });
                  }} />
              </Row>
            ) : (
              <>
                <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                  <Col span={24}>
                    <FormControl variant="outlined" className={classes.formControl} fullWidth>
                      <InputLabel id="yt-video-label" style={{ backgroundColor: "#fff", paddingLeft: 2, paddingRight: 2 }}>Youtube video url</InputLabel>
                      <TextAreaAuto
                        id="yt-video-input"
                        type="text"
                        minRows={3}
                        maxRows={5}
                        variant="outlined"
                        onBlur={e => handleCheckUrlChange(e)}
                        placeholder="https://youtube.com/watch"
                        onChange={(e) => {
                          setError(false)
                          setTip({
                            ...tip,
                            yt_video: e.target.value,
                          });
                        }}
                        value={get(tip, "yt_video")}
                      />
                    </FormControl>
                  </Col>
                </Row>
                {get(tip, "yt_video") && isYoutubeUrl(get(tip, "yt_video")) && (
                  <PreviewContainer>
                    <PreviewLabel>Preview</PreviewLabel>
                    <YouTubePlayer
                      url={get(tip, "yt_video")}
                      playerId={`youtube-preview-${pageId}-${bookId}`}
                      is_valid={true}
                    />
                  </PreviewContainer>
                )}
              </>
            )}
          </LinkArea>
        </ModalConfigArea>
        <ModalConfigArea style={{ overflowX: "hidden" }}>
          {error ? (
            <FormHelperText error>
              A description, video, or YouTube URL is required!
            </FormHelperText>
          ) : null}
          <Row
            gutter={[24, 24]}
            style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
          >
            <Button
              fullWidth
              // disabled={}
              onClick={onUpdate}
              color="primary"
              variant="contained"
            >
              {loading ? <Loading white size={14} /> : null}   {data ? "Update" : "Create"}
            </Button>
          </Row>
        </ModalConfigArea>
      </ModalContent>
    </Modal>)
}

export default TipsModal;